/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Col, Form, Row, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { watchOptionsList, getListOptions } from '@/redux/slices/options.slice';
import { useEffect, useMemo } from 'react';
import { Button } from '@/components/button';

type BannerSliderSearcherProps = {
  onSearch: (values: FilterBanner) => void;
};

export const BannerSliderSearcher = ({
  onSearch
}: BannerSliderSearcherProps) => {
  const [form] = Form.useForm();
  const platformList = useAppSelector(watchOptionsList);
  const dispatch = useAppDispatch();
  const statusData = [
    {
      name: 'Tất cả',
      value: 3
    },
    {
      name: 'Hiển thị',
      value: 1
    },
    {
      name: 'Ẩn',
      value: 2
    }
  ];

  const statusOptions = [
    ...statusData.map((status) => ({
      value: status.value,
      label: status.name
    }))
  ];

  const platformOptions = useMemo(
    () => [
      {
        value: 0,
        label: 'Tất cả'
      },
      ...platformList.map((platform) => ({
        value: platform.id,
        label: platform.name
      }))
    ],
    [platformList]
  );

  const handleSearch = () => {
    const values = form.getFieldsValue();
    onSearch(values);
  };

  useEffect(() => {
    dispatch(getListOptions({ code: 'PLAT_FORM' }));
  }, [dispatch]);
  return (
    <Form
      form={form}
      name='banner-slider-searcher'
      layout='horizontal'
      css={rootStyles}
    >
      <Row align='bottom' gutter={[10, 0]}>
        <Col
          css={css`
            width: 40rem;
          `}
        >
          <Form.Item
            label='Nền tảng'
            name='platform'
            initialValue={0}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              showSearch
              allowClear
              placeholder='Tất cả'
              optionFilterProp='label'
              options={platformOptions}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label='Trạng thái'
            name='active'
            initialValue={3}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              showSearch
              allowClear
              placeholder='Tất cả'
              optionFilterProp='label'
              options={statusOptions}
            />
          </Form.Item>
        </Col>
        <Col>
          <Button
            type='default'
            icon={<SearchOutlined />}
            iconPosition='start'
            onClick={handleSearch}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const rootStyles = css`
  .ant-form-item-label {
    padding: 0;
    label {
      height: auto;
    }
  }
  .ant-form-item {
    margin-bottom: 0;
  }
`;
